import type {
  TMentionFacets,
  TRange,
} from '@/features/mentions/components/MentionFilters/active-options/active-options';
import { mediaManagerClient } from '@/lib/axios';

/**
 * RISK: deliberately outside `clipsQueryKeys.all`. Under `['clips']` some clip mutations would
 * refresh it and others not, and `patchClipCache` and `post-clips-batch` write into every entry
 * there assuming it is a clip cache.
 */
export const clipMentionFacetsQueryKey = (range: TRange) => ['clip-mention-facets', range] as const;

export async function getClipMentionFacets({ gte, lte }: TRange): Promise<TMentionFacets> {
  return mediaManagerClient.get('/api/v1/clip_mention_facets', {
    params: {
      start_datetime__gte: gte || undefined,
      end_datetime__lte: lte || undefined,
    },
  });
}
